import FindRecipientPersonaType from './FindRecipientPersonaType';
import { PeopleFeedbackState } from './PeopleFeedbackState';
import { FeedbackManagerState } from 'owa-feedback-manager/lib/store/schema/FeedbackManagerState';

export enum FindResultType {
    None,
    Cache,
    FindPeople,
    SearchDirectory,
    MixedCacheLive,
}

interface FindControlViewState {
    queryString: string;
    findPeopleFeedbackManager: FeedbackManagerState;
    findResultSet: FindRecipientPersonaType[];
    findResultType: FindResultType;
    findResultHightlightIndex: number;
    findResultTransactionId?: string;
    isSearching: boolean;
    hasSearchedDirectory: boolean;
    shouldShowFindResult: boolean;
    inForceResolve?: boolean;
    currentRenderedQueryString?: string;
    peopleFeedbackState?: PeopleFeedbackState;
}

export default FindControlViewState;
